<template>
  <div class="activity_sign_in_container">
    <div class="sign_in_box" v-if="!!activity">
      <img :src="activity.pictureUrl" alt="" v-if="!!activity.pictureUrl && activity.pictureUrl.length > 0" />
      <div class="activity_name" v-text="activity.activityName"></div>
      <div class="sign_form">
        <div class="sign_form_item">
          <input type="text" class="phone" v-model="phone" placeholder="请输入报名手机号码" />
        </div>
        <div class="sign_form_item">
          <input type="text" class="code" v-model="code" placeholder="请输入验证码" />
          <button class="send_code" ref="timeLocation" @click="sendCode($event)">
            发送验证码
          </button>
        </div>
        <div class="sign_operate">
          <span class="operate_btn" @click="submitSignIn">马上签到</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { testMobilePhone, loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
export default {
  name: "SignIn",
  data() {
    return {
      params: {
        contentType: 1,
        activityId: null,
        cId: 0,
      },
      activity: null, // 活动详情
      phone: "",
      code: "",
      timePicker: null,
      pageData: {
        title: "",
        info: "",
        shareUrl: "",
        imageUrl: ""
      },
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "shareRootUrl"]),
  },
  methods: {
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.params)
        .then((res) => {
          if (res.suc == 1) {
            _this.activity = res.data;
            _this.pageData.title = _this.activity.activityName;
            _this.pageData.imageUrl = _this.activity.sharePictureUrl;
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 禁用发送验证码，开始倒计时 */
    startCountDown() {
      var _this = this;
      var time = 59;
      if (_this.$refs.timeLocation) {
        _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
        _this.$refs.timeLocation.disabled = true;
      }
      _this.timePicker = setInterval(function () {
        time--;
        if (time == 0) {
          clearInterval(_this.timePicker);
          if (_this.$refs.timeLocation) {
            _this.$refs.timeLocation.innerHTML = "发送验证码";
            _this.$refs.timeLocation.disabled = false;
          }
        } else {
          if (_this.$refs.timeLocation) {
            _this.$refs.timeLocation.innerHTML = "请(" + time + ")秒后重新获取";
          }
        }
      }, 1000);
    },
    /* 禁用发送验证码，停止倒计时 */
    stopCountDown() {
      var _this = this;
      clearInterval(_this.timePicker);
      _this.$refs.timeLocation.innerHTML = "发送验证码";
      _this.$refs.timeLocation.disabled = true;
    },
    /* 发送验证码 */
    sendCode(e) {
      var _this = this;
      if (testMobilePhone(_this.phone)) {
        _this.startCountDown();
        var params = {
          activityId: _this.activity.id,
          mobilephone: _this.phone,
          nodeCode: _this.nodeCode,
          important: true,
        };
        activityApi
          .getAuthCodeBySignIn(params)
          .then((res) => {
            if (res.suc == 1 && !!res.data) {
              switch (Number(res.data.status)) {
                case 1:
                  _this.$dialog
                    .confirm({
                      message: "该手机号尚未报名，现在去报名？",
                    })
                    .then(() => {
                      _this.$router.push({
                        path: "/activity_detail",
                        query: {
                          activityId: this.activity.id,
                        },
                      });
                    })
                    .catch(() => { });
                  _this.stopCountDown();
                  break;
                case 2:
                  _this.$dialog.alert({
                    message:
                      "很抱歉，您的报名信息处于待审核状态，审核通过以后再来试试吧！",
                  });
                  _this.stopCountDown();
                  break;
                case 3:
                  _this.$dialog
                    .confirm({
                      message:
                        "很遗憾，您的报名未通过审核，现在去提交新的报名信息？",
                    })
                    .then(() => {
                      this.$router.push({
                        path: "/activity_detail",
                        query: {
                          activityId: this.activity.id,
                        },
                      });
                    })
                    .catch(() => { });
                  _this.stopCountDown();
                  break;
                case 4:
                  /** 报名审核通过，未签到 **/
                  if (
                    res.data.authCodeInfo &&
                    Number(res.data.authCodeInfo.result) == 1
                  ) {
                    _this.$toast({
                      message: "验证码已发送！",
                      position: "center",
                    });
                  } else {
                    _this.$toast({
                      message: "发送验证码失败,请稍后再试!",
                      position: "center",
                    });
                  }
                  break;
                case 5:
                  _this.$dialog
                    .alert({
                      message: "您已经签过到了！",
                    })
                    .then(() => {
                      this.$router.push({
                        path: "/activity_detail",
                        query: {
                          activityId: this.activity.id,
                        },
                      });
                    });
                  _this.stopCountDown();
                  break;
                default:
                  _this.$toast({
                    message: "出错了，请稍后重试。",
                    position: "center",
                  });
                  _this.stopCountDown();
                  break;
              }
            } else {
              _this.$toast({
                message: "出错了，请稍后重试！",
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "出错了，请稍后重试！",
              position: "center",
            });
          });
      } else {
        _this.$toast({
          message: "请输入正确的手机号码！",
          position: "center",
        });
      }
    },
    /* 提交签到 */
    submitSignIn() {
      var _this = this;
      if (!_this.userInfo) {
        _this.$toast({
          message: "请先登录！",
          position: "center",
        });
        return;
      } else if (!testMobilePhone(_this.phone)) {
        _this.$toast({
          message: "请输入正确的手机号码！",
          position: "center",
        });
        return;
      } else if (_this.code.length != 6) {
        _this.$toast({
          message: "请输入正确的验证码！",
          position: "center",
        });
        return;
      }
      var params = {
        activityId: _this.activity.id,
        memberId: _this.userInfo.id,
        phone: _this.phone,
        verifyCode: _this.code,
      };
      activityApi
        .activitySignInByPhone(params)
        .then((res) => {
          if (res.suc == 1 || res.suc == 2) {
            _this.$dialog
              .alert({
                message: res.message,
              })
              .then(() => {
                _this.$router.push({
                  path: "/activity_detail",
                  query: {
                    activityId: _this.activity.id,
                  },
                });
              });
            _this.stopCountDown();
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    document.title = "活动签到";
    var _this = this;
    let query = _this.$route.query;

    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      _this.params.activityId = query.activityId;
      _this.getActivityDetail();

      // 定时器用来解决不能及时获取到用户信息的问题
      var tm = setInterval(function () {
        if (!!_this.userInfo) {
          clearInterval(tm);
          _this.phone = _this.userInfo.mobilePhone;
        }
      }, 500);

      _this.pageData.info = "活动签到";
      _this.pageData.shareUrl = _this.shareRootUrl + "index_share?contentType=activity_sign&activityId=" + _this.params.activityId + "&contentCode=" + _this.nodeCode;
      // 提供给客户端调用，设置分享信息
      _this.$bridge.registerhandler("getShareInfo", function () {
        // 调用客户端方法，将分享信息传给客户端
        _this.$bridge.callhandler("setShareInfo", JSON.stringify(_this.pageData), function (res) { });
      });

      loadStat(); // 友盟统计
    } else {
      _this.$router.replace({
        path: "/error",
      });
    }

  },
};
</script>
<style scoped lang="scss">
.activity_sign_in_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  .sign_in_box {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
    .activity_name {
      padding: 5px 0;
      line-height: 32px;
    }
    .sign_form {
      .sign_form_item {
        position: relative;
        .phone,
        .code {
          width: 100%;
          height: 36px;
          padding: 5px;
          line-height: 24px;
          border: 1px solid #ccc;
          border-radius: 5px;
          box-sizing: border-box;
          margin-top: 10px;
          font-size: 14px;
        }
        .send_code {
          position: absolute;
          right: 3px;
          bottom: 3px;
          height: 28px;
          padding-left: 8px;
          padding-right: 8px;
          line-height: 28px;
          background-color: #397ef5;
          border: none;
          color: #fff;
          font-size: 12px;
          &:disabled {
            background-color: #666;
          }
        }
      }
      .sign_operate {
        display: flex;
        width: 100%;
        height: 40px;
        margin-top: 10px;
        .operate_btn {
          flex: 1;
          height: 40px;
          line-height: 40px;
          background-color: #397ef5;
          text-align: center;
          color: #fff;
          font-size: 16px;
        }
      }
    }
  }
}
</style>